var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentStatusEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "81px",
    height: "81px",
    viewBox: "0 0 81 81",
    style: {
      enableBackground: "new 0 0 81 81"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#D4BC87;stroke-width:1.5;}\n\t.st1{fill:#D4BC87;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 40.5,
    cy: 40.5,
    r: 30.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.7,30L29.7,30h21.7c1.3,0,2.4,1.1,2.4,2.4v16.3c0,1.3-1.1,2.4-2.4,2.4H29.7c-1.3,0-2.4-1.1-2.4-2.4V32.3 C27.3,31,28.4,30,29.7,30z M29.8,34.6l-0.5-0.4v0.6v13.7V49h0.3h21.7h0.3v-0.3V34.9v-0.6l-0.5,0.4l-10.7,7.1L29.8,34.6z M30.7,32 h-1.1l0.9,0.6l9.8,6.5l0.2,0.1l0.2-0.1l9.8-6.5l0.9-0.6h-1.1H30.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatusEmail);
export default __webpack_public_path__ + "static/media/payment-status-email.b26132cc03cda4c4e8740276c78076f0.svg";
export { ForwardRef as ReactComponent };